module.exports = __webpack_public_path__ + "img/BRCA1_Treg.b2ded9ac.png";